import { render, staticRenderFns } from "./MiniIndex.vue?vue&type=template&id=a3f79852&scoped=true&"
import script from "./MiniIndex.vue?vue&type=script&lang=js&"
export * from "./MiniIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f79852",
  null
  
)

export default component.exports